import React from 'react';
import { TextField, Autocomplete } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { useGetPayersQuery } from '../../../../../services/ConfigurationService';
import { updateEstimateBasicInfo } from '../../../../../services/ContractService/contractEstimateSlice';
import { PayerType } from '../../../../../services/ConfigurationService/types/payerType';

export const EstimatePayerEditor: React.FC = () => {
  const [searchParams] = useSearchParams();
  const company = searchParams.get('company') || '';
  
  const dispatch = useAppDispatch();
  const estimate = useAppSelector(state => state.contractEstimate.currentEstimate);
  const errors = useAppSelector(state => state.contractEstimate.validationErrors);

  // Fetch payers data
  const { data: payers = [], isLoading: payersLoading } = useGetPayersQuery(
    { company, centerId: estimate?.centerId || '' },
    { skip: !company || !estimate?.centerId }
  );

  // Sort payers by payerName
  const sortedPayers = [...payers].sort((a, b) => a.payerName.localeCompare(b.payerName));

  const selectedPayer = sortedPayers.find(p => p.id === estimate?.payerId);

  const handlePayerChange = (payer: PayerType | null) => {
    dispatch(updateEstimateBasicInfo({
      payerId: payer?.id || '',
      payerName: payer?.payerName
    }));
  };

  return (
    <Autocomplete
      value={selectedPayer || null}
      onChange={(_, value) => handlePayerChange(value)}
      options={sortedPayers}
      getOptionLabel={(option) => `${option.payerCode} - ${option.payerName}`}
      loading={payersLoading}
      disabled={!estimate?.centerId}
      size="small"
      renderInput={(params) => (
        <TextField
          {...params}
          label="Payer"
          required
          error={!!errors.payerId}
          helperText={errors.payerId || (!estimate?.centerId ? 'Select a center first' : '')}
        />
      )}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      sx={{ minWidth: { xs: '100%', md: 600 } }}
    />
  );
};